import React, { useCallback } from 'react';
import { Checkbox, Form } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { useIntl } from 'react-intl';

import styles from './styles.module.scss';

export interface InstalmentCardFutureHeaderProps {
  cardSlot: 'card1' | 'card2';
  /** e.g. "Card 1:" — include trailing colon in string */
  sectionTitle: string;
}

export function InstalmentCardFutureHeader({
  cardSlot,
  sectionTitle,
}: InstalmentCardFutureHeaderProps): React.ReactElement {
  const intl = useIntl();
  const form = Form.useFormInstance();
  const primary = Form.useWatch('primaryInstalmentCard', form) ?? 'card1';
  const checked =
    (cardSlot === 'card1' && primary === 'card1') || (cardSlot === 'card2' && primary === 'card2');

  const handleChange = useCallback(
    (e: CheckboxChangeEvent) => {
      if (e.target.checked) {
        form.setFieldValue('primaryInstalmentCard', cardSlot === 'card1' ? 'card1' : 'card2');
        return;
      }
      form.setFieldValue('primaryInstalmentCard', cardSlot === 'card1' ? 'card2' : 'card1');
    },
    [cardSlot, form],
  );

  return (
    <div className={styles.row}>
      <p className={styles.title}>{sectionTitle}</p>
      <div className={styles.trailing}>
        <Checkbox className={styles.checkbox} checked={checked} onChange={handleChange}>
          {intl.formatMessage({ id: 'certificates.payment.useForFuture' })}
        </Checkbox>
        <FontAwesomeIcon icon={faCircleInfo} className={styles.infoIcon} aria-hidden />
      </div>
    </div>
  );
}
